import { useEffect, useState } from 'react'

const getIsPortrait = () =>
  typeof window !== 'undefined' && window.innerHeight >= window.innerWidth

const useDeviceOrientation = () => {
  const [isPortrait, setIsPortrait] = useState(getIsPortrait)

  useEffect(() => {
    const update = () => setIsPortrait(getIsPortrait())
    window.addEventListener('resize', update)
    window.addEventListener('orientationchange', update)
    return () => {
      window.removeEventListener('resize', update)
      window.removeEventListener('orientationchange', update)
    }
  }, [])

  return { isPortrait }
}

export default useDeviceOrientation